import React from 'react'
import { Box, CenteredBox, FreeSquizButton, H1 } from './layout'
import { Explosion, Eye, Lines, Target, useCalendar } from './widgets'
import { Ellipse } from './index/'
import './CallToAction.css'

export const CallToAction = () => {
  const { openCalendar } = useCalendar()

  return (
    <CenteredBox
      container
      column
      fullWidth
      height="100dvh"
      gap={48}
      px={32}
    >
      <Box
        position="absolute"
        top={0}
        fullWidth
        height="100dvh"
        background="linear-gradient(180deg, #000 0%, #0A0A57 36.21%, #00F 68.68%, #5555FC 86.54%)"
        alignItems="end"
        zIndex={-1}
      >
        <Ellipse />
      </Box>

      <H1 weight={500}>Ready to see<br/>how it really<br/>works?</H1>
      <Box gap={16} className="call-to-action-buttons">
        <button onClick={openCalendar}>Book a Walkthrough</button>
        <FreeSquizButton />
      </Box>

      <Lines top={150} left={50} animate reverse />
      <Eye top={250} right={500} animate animationDelay="-5s" reverse />
      <Explosion top={500} right={370} animate />
      <Target top={400} left={520} animate animationDelay="-10s" />
    </CenteredBox>
  )
}